// external imports
import React from 'react'
import Helmet from 'react-helmet'
import { H3 } from 'quark-web'
// local imports
import { Text, Header, Carousel } from '~/components'
import styles from './styles'
import {FlexColumn} from 'quark-web'
import './../basicResponsive.css'

const Splash = () => (
    <div>
        <Helmet title="Company" />

        <FlexColumn
         justifyContent="center"
         style={styles.column}>
            <Header style={styles.header}>Company</Header>
            <div className={'content'}>
                <Text>
                    Founded in 1997, Lark Seeds International is becoming today a global leader in 
                    the vegetable seed industry.{"\n\n"}

                    Our product line offers a wide variety of premium hybrid vegetable seeds that deliver 
                    above-average quality with higher yield and disease resistances. {"\n\n"}

                    Our network of breeding facilities is located in the United States, Canada, and 
                    Mexico and our trial stations span across Europe, the Middle East, North Africa, 
                    and South America. {"\n\n"}
                    
                    Our global team works locally with our clients to address the specific needs of 
                    their markets and provide the best solutions. {"\n\n"}

                    We take pride in ensuring our clients' satisfaction. Our goal is building long-lasting
                    relationships and providing innovative products for optimal results.
                </Text>
            </div>
        </FlexColumn>
    </div>
)

export default Splash



// WEBPACK FOOTER //
// ./src/views/Company/index.js